import React from "react";
import { Link } from "react-router-dom";

const MenuLink = ({ item }) => {
  const pathname = window.location.pathname;
  const isActive = pathname === item.path;

  const handleClick = (e) => {
    if (item.onClick) {
      e.preventDefault();
      item.onClick();
    }
  };

  const linkClasses = `flex gap-4 items-center px-6 h-[40px] rounded-lg transition-all duration-300 ease-in-out transform hover:translate-x-1 ${
    isActive
      ? "bg-[#cfabff33] border border-white/10 shadow-[0px_0px_0px_1.5px_rgba(255,255,255,0.06)] flex leading-[20px] items-center gap-4 text-white"
      : "text-[#848D94] hover:bg-[#cfabff33] border border-transparent hover:border-white/10 hover:text-white"
  }`;

  const iconClasses = `transition-transform duration-300 ${
    isActive ? "scale-110" : "group-hover:scale-110"
  }`;

  if (item.isExternal) {
    return (
      <a
        href={item.path}
        target="_blank"
        rel="noopener noreferrer"
        className={linkClasses}
      >
        <div className={iconClasses}>{item.icon}</div>
        <h5 className="font-medium text-sm transition-colors duration-300">
          {item.title}
        </h5>
      </a>
    );
  }

  return (
    <Link to={item.path} onClick={handleClick} className={linkClasses}>
      <div className={iconClasses}>{item.icon}</div>
      <h5 className="font-medium text-sm transition-colors duration-300">
        {item.title}
      </h5>
    </Link>
  );
};

export default MenuLink;
